import { msg } from "../locales/translate";
import { DataProvider } from "badmfck-signal";
import { IExecutorResponse } from "badmfck-signal/dist/DataProvider";
import { GD } from "src/GD";
import { IAcquirerChannel } from "src/types/types";

export class AcquirerService {
	acquirers: DataProvider<{ projectID: number }, IAcquirer[]> = new DataProvider({ cacheTime: 0 }, "Acquirers");

	// routes: {
	// 	[key: string]: DataProvider<
	// 		{ projectID: number; acquirer_id: number },
	// 		IAcquirerRoute[]
	// 	>;
	// } = {};

	constructor() {
		this.acquirers.setExecutor(async () => {
			const pid = await GD.REQ_CURRENT_PROJECT.request();
			return (await GD.REQ_API.request({
				method: "acquirers/list",
				apiVersion: 2,
				data: {
					project_id: pid?.id,
				},
			})) as IExecutorResponse<IAcquirer[]>;
		});
		GD.REQ_ACQUIRER.listener = async req => this.getAcquirer(req);
		GD.REQ_ACQUIRER_SAVE.listener = async req => this.saveAcquirer(req);
		GD.B_ACQUIRERS.onRequest(async () => GD.B_ACQUIRERS.invoke(await this.acquirers.load()));
		// GD.REQ_ACQUIRER_ROUTE.listener = async req =>
		// 	this.getAcquirerChannel(req);

		GD.S_ACQUIRERS_CHANGE.subscribe(() => {
			this.acquirers.reset();
			GD.B_ACQUIRERS.execute({ ts: +new Date() });
		});

		GD.REQ_ACQUIRER_ROUTE.listener = async req => this.getAcquirerRoute(req);

		GD.REQ_ACQUIRER_CHANNEL_SAVE.listener = async req => this.saveAcquirerChannel(req);

		GD.REQ_ACQUIRER_CHANNEL.listener = async req => this.getAcquirerChannel(req);

		GD.REQ_ACQUIRER_ROUTE_SAVE.listener = async req => this.saveAcquirerRoute(req);

		GD.S_PROJECT_SELECTED.subscribe(() => {
			this.acquirers.reset();
		});

		GD.REQ_CHANNELS.listener = async req => this.getChannels(req);
	}

	async getChannels(req: { acquirerId?: number; terminalId?: number; showDeleted?: boolean }): Promise<IAPIResponse<IAcquirerChannel[]>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		let res: IAPIResponse = { error: { code: -1, message: msg("noData") } };

		//!TODO: cache;

		res = await GD.REQ_API.request({
			method: "channels/list",
			data: {
				acquirer_id: req.acquirerId,
				terminal_id: req.terminalId,
				show_deleted: req.showDeleted,
			},
		});
		return res;
	}

	async getAcquirerRoute(req: { routeID: number; acquirerID: number }): Promise<IAPIResponse<IAcquirerRoute>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		if (req.routeID === 0) {
			const channel = await this.generateNewRoute(req.acquirerID);
			return { data: channel };
		}

		const route = await GD.REQ_API.request({
			method: "channels/get",
			data: {
				id: req.routeID,
			},
		});

		return route;
	}

	async getAcquirerChannel(req: { channelId: number; acquirerID: number }): Promise<IAPIResponse<IAcquirerChannel>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		//!TODO: не оптимально, повторный запрос; также обработать ошибку;
		//
		// const acq = await GD.REQ_ACQUIRER.request({
		// 	acquirerID: req.acquirerID,
		// });

		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const acquirerID = req.acquirerID;
		const channelID = req.channelId;

		if (channelID === 0) {
			if (acquirerID === undefined) return { error: { code: -1, message: msg("invalidAcquirerId") } };

			const channel = await this.generateNewChannel(acquirerID);
			return { data: channel };
		}

		const channel = await GD.REQ_API.request({
			method: "channels/get",
			data: {
				id: req.channelId,
				acquirer_id: req.acquirerID,
			},
		});

		return channel;
	}

	async generateNewRoute(acquirerID: number): Promise<IAcquirerRoute> {
		const newRoute: IAcquirerRoute = {
			acquirer_id: acquirerID,
			description: "",
			name: "",
			source: "crm",
			status: "active",
			terminal_id: -1,
		};
		return newRoute;
	}

	async generateNewChannel(acquirerID: number): Promise<IAcquirerChannel> {
		const channel: IAcquirerChannel = {
			acquirer_id: acquirerID,
			alias: "",
			id: 0,
			title: "",
			title_system: "",
			created_at: undefined,
			deleted_at: undefined,
			updated_at: undefined,
			source: "crm",
			terminal_id: null,
			channel_type: "aggregated",
			link_status: "active",
		};
		return channel;
	}

	async generateNewAcquirer(): Promise<IAcquirer> {
		const res: IAcquirer = {
			created_at: undefined,
			name: "",
			updated_at: undefined,
			id: -1,
			project_id: (await GD.REQ_CURRENT_PROJECT.request())?.id ?? -1,
			country: undefined,
			timezone: "UTC",
		};
		return res;
	}

	async getAcquirer(req: { acquirerID: number }): Promise<IAPIResponse<IAcquirer> | null> {
		//if (!req) return { error: { code: -1, message: "Invalid getAcquirer request" } };
		if (!req) return null;
		const acquirerID = req.acquirerID;

		if (!acquirerID) return { error: { code: -1, message: msg("invalidAcquirerUid") } };

		if (acquirerID === -1) {
			return {
				data: await this.generateNewAcquirer(),
			};
		}

		const client = await GD.REQ_API.request({
			method: "acquirers/get",
			apiVersion: 2,
			data: {
				id: acquirerID,
			},
		});

		return client;
	}

	async saveAcquirerRoute(req: IAcquirerRoute): Promise<IAPIResponse<IAcquirerRoute>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		let res: IAPIResponse = { error: { code: -1, message: msg("noData") } };

		if (!req.id || req.id === -1) {
			// NEW ADD
			//!TODO: change call;

			res = await GD.REQ_API.request({
				method: "acquirers/routes/add",
				data: req,
			});

			// res = await GD.REQ_API.request({
			// 	method: "acquirer/channel/add",
			// 	data: req,
			// });
		}

		return res;
	}

	async saveAcquirerChannel(req: IAcquirerChannel): Promise<IAPIResponse<IAcquirerChannel>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		let res: IAPIResponse = { error: { code: -1, message: msg("noData") } };

		res = await GD.REQ_API.request({
			method: "channels/add",
			data: req,
		});

		if (res && !res.error) {
			GD.S_CHANNELS_UPDATE.invoke({});
		}
		return res;
	}

	async saveAcquirer(req: IAcquirer): Promise<IAPIResponse<IAcquirer>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		let res: IAPIResponse = { error: { code: -1, message: msg("noData") } };
		const { channels, updated_at, ...dataToSave } = req;
		res = await GD.REQ_API.request({
			method: "acquirers/add",
			data: dataToSave,
		});

		if (res && !res.error) {
			this.acquirers.reset();
			GD.B_ACQUIRERS.invoke(await this.acquirers.load());
			//  GD.REQ_ACQUIRER.request({acquirerID:req.id})
		}
		return res;
	}
}
